import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "relative isolate overflow-hidden inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold transition-[transform,color,background-color,border-color] duration-200 hover:-translate-y-px active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 before:absolute before:inset-0 before:-z-10 before:transition-transform before:duration-300 before:ease-out",
  {
    variants: {
      variant: {
        default:
          "bg-slate-900 text-white shadow-[0_8px_24px_-12px_rgba(15,23,42,0.6)] before:bg-sky-600 before:scale-x-0 before:origin-left hover:before:scale-x-100",
        destructive:
          "bg-red-600 text-white before:bg-red-700 before:scale-x-0 before:origin-left hover:before:scale-x-100",
        outline:
          "border border-slate-300 bg-white text-slate-800 before:bg-slate-900 before:translate-y-full hover:before:translate-y-0 hover:text-white hover:border-slate-900",
        secondary:
          "bg-slate-100 text-slate-900 before:bg-slate-200 before:scale-x-0 before:origin-left hover:before:scale-x-100",
        ghost: "hover:bg-slate-100 text-slate-700",
        link: "text-sky-700 underline-offset-4 hover:underline before:hidden",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 px-3.5 text-xs",
        lg: "h-11 px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
